import styled from "@emotion/styled";
import { Box } from "@mui/material";

const FaceContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 70,
  height: 142,
  transition: "opacity 0.15s cubic-bezier(0.22, 1, 0.36, 1)",
  [theme.breakpoints.up("mobile")]: {
    width: 102,
    height: 171,
  },
}));

export default FaceContainer;
